export class Topic {
  TopicId: number;
  TopicName: string;
}
